import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import ProductBlock from "./product-block";
import styled from "styled-components";
import { parsePrice } from "../utils/helpers";

const Wrapper = styled.div.attrs(({ $columns }) => ({
  $columns: $columns || 1,
}))`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  gap: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-rows: auto;
    grid-template-columns: repeat(2, 1fr);
  }
  .price {
    font-family:var(--font-headings); "sans-serif";
  }
`;

const MultipleProductsBlock = ({
  rows,
  columns,
  showAddToCartButton,
  showPrice,
  showTitle,
  products,
  alignButtons,
  orderby,
}) => {
  const visibleNr = columns * rows;
  const [filteredProducts, setProducts] = React.useState(products);
  const { wp } = useStaticQuery(graphql`
    query PriceQuery {
      wp {
        wcSettings {
          currency
          priceDecimalSeparator
          priceThousandSeparator
        }
      }
    }
  `);
  React.useEffect(() => {
    if (orderby && orderby === "title") {
      setProducts(
        [...filteredProducts].sort((a, b) => (a.name > b.name ? 1 : -1))
      );
    }
    if (orderby && orderby === "price_asc") {
      setProducts(
        [...filteredProducts].sort(
          (a, b) =>
            a.price &&
            parsePrice(
              a?.price,
              wp.wcSettings.priceThousandSeparator,
              wp.wcSettings.priceDecimalSeparator
            ) > b.price &&
            parsePrice(
              b?.price,
              wp.wcSettings.priceThousandSeparator,
              wp.wcSettings.priceDecimalSeparator
            )
        )
      );
    }
    if (orderby && orderby === "price_desc") {
      setProducts(
        [...filteredProducts].sort(
          (a, b) =>
            b.price &&
            parsePrice(
              b?.price,
              wp.wcSettings.priceThousandSeparator,
              wp.wcSettings.priceDecimalSeparator
            ) > a.price &&
            parsePrice(
              a.price,
              wp.wcSettings.priceThousandSeparator,
              wp.wcSettings.priceDecimalSeparator
            )
        )
      );
    }
    if (orderby && orderby === "date") {
      setProducts(
        [...filteredProducts].sort(
          (a, b) => new Date(a.date) > new Date(b.date)
        )
      );
    }
  }, [orderby]);

  React.useEffect(() => {
    if (rows && columns) {
      setProducts(filteredProducts?.slice(0, visibleNr));
    } else {
      setProducts(filteredProducts);
    }
  }, [rows, columns]);

  return (
    <Wrapper $rows={rows} $columns={columns}>
      {filteredProducts?.map((product) => (
        <ProductBlock
          product={product}
          key={product.id}
          showAddToCartButton={showAddToCartButton}
          showPrice={showPrice}
          showTitle={showTitle}
          alignButtons={alignButtons}
          heartIconSize="small"
          showExcerpt={true}
        />
      ))}
    </Wrapper>
  );
};

MultipleProductsBlock.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  showAddToCartButton: PropTypes.bool,
  showPrice: PropTypes.bool,
  showTitle: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.object),
  alignButtons: PropTypes.bool,
  orderby: PropTypes.string,
};

export default MultipleProductsBlock;
